import { defineMessages } from 'react-intl';

/** The copy of the results (design outreach-v2 n1, n2, n3). */
export const resultsMessages = defineMessages({
  // funnel
  pitched: { id: 'app.outreach.resultsV2.funnel.pitched', defaultMessage: 'Pitched' },
  opened: { id: 'app.outreach.resultsV2.funnel.opened', defaultMessage: 'Opened the song' },
  listened: { id: 'app.outreach.resultsV2.funnel.listened', defaultMessage: 'Listened 30 s+' },
  replied: { id: 'app.outreach.resultsV2.funnel.replied', defaultMessage: 'Replied' },
  added: { id: 'app.outreach.resultsV2.funnel.added', defaultMessage: 'Added {song}' },
  inDays: {
    id: 'app.outreach.resultsV2.funnel.inDays',
    defaultMessage: 'in {count, plural, one {# day} other {# days}}',
  },
  ofPitched: { id: 'app.outreach.resultsV2.funnel.ofPitched', defaultMessage: '{percent}% of pitched' },
  percent: { id: 'app.outreach.resultsV2.funnel.percent', defaultMessage: '{percent}%' },
  repliedInterested: {
    id: 'app.outreach.resultsV2.funnel.repliedInterested',
    defaultMessage: '{percent}% · {count} interested',
  },
  addedFollowers: {
    id: 'app.outreach.resultsV2.funnel.addedFollowers',
    defaultMessage: '{percent}% · {followers} followers',
  },

  // the first week (n3): a note under the totals
  tooEarlyBody: {
    id: 'app.outreach.resultsV2.tooEarly.body',
    defaultMessage:
      'Most replies come 2 to 6 days after a pitch, and most adds come 1 to 3 weeks after it. Results fill in from next week. You get a push for each reply and each add.',
  },

  // day by day (t6)
  dailyTitle: { id: 'app.outreach.resultsV2.daily.title', defaultMessage: 'Day by day' },
  dailyIntro: {
    id: 'app.outreach.resultsV2.daily.intro',
    defaultMessage: 'The pitches of each day and what they got so far. A green dot is a day with an add.',
  },
  dailyPitched: { id: 'app.outreach.resultsV2.daily.pitched', defaultMessage: 'Pitched' },
  dailyOpened: { id: 'app.outreach.resultsV2.daily.opened', defaultMessage: 'Opened' },
  dailyListened: { id: 'app.outreach.resultsV2.daily.listened', defaultMessage: 'Listened 30 s+' },
  dailyReplied: { id: 'app.outreach.resultsV2.daily.replied', defaultMessage: 'Replied' },
  dailyAdded: { id: 'app.outreach.resultsV2.daily.added', defaultMessage: 'Added' },
  dailyEmpty: {
    id: 'app.outreach.resultsV2.daily.empty',
    defaultMessage: 'The chart starts with the first pitch.',
  },
  dailyBar: {
    id: 'app.outreach.resultsV2.daily.bar',
    defaultMessage: '{day}: {pitched} pitched, {opened} opened, {listened} listened, {replied} replied, {added} added',
  },

  // what happened (t6)
  feedTitle: { id: 'app.outreach.resultsV2.feed.title', defaultMessage: 'What happened' },
  feedEmpty: {
    id: 'app.outreach.resultsV2.feed.empty',
    defaultMessage: 'Nothing yet. Each send, listen, reply and add shows here.',
  },
  feedMore: { id: 'app.outreach.resultsV2.feed.more', defaultMessage: 'Show more' },

  // streams
  streamsTitle: { id: 'app.outreach.resultsV2.streams.title', defaultMessage: '{song} streams, every day' },
  streamsIntro: {
    id: 'app.outreach.resultsV2.streams.intro',
    defaultMessage: '{source}. The green lines are the adds that Plug found.',
  },
  streamsNone: {
    id: 'app.outreach.resultsV2.streams.none',
    defaultMessage: 'Connect Spotify for Artists to see the streams of the song next to the adds.',
  },
  streamsNow: {
    id: 'app.outreach.resultsV2.streams.now',
    defaultMessage:
      '{perDay} streams a day now, {total} since the release. Plug cannot prove which stream came from which add; the lines show when they happened.',
  },
  streamsChart: {
    id: 'app.outreach.resultsV2.streams.chart',
    defaultMessage:
      'Daily streams from {from} to {to}, with {adds, plural, one {# day of adds} other {# days of adds}}',
  },
  pinOut: { id: 'app.outreach.resultsV2.streams.pinOut', defaultMessage: 'OUT' },
  pinAdds: { id: 'app.outreach.resultsV2.streams.pinAdds', defaultMessage: '+{count}' },
  sourceSpotifyForArtists: {
    id: 'app.outreach.resultsV2.source.spotifyForArtists',
    defaultMessage: 'Spotify for Artists',
  },
  sourceDitto: { id: 'app.outreach.resultsV2.source.ditto', defaultMessage: 'Ditto' },
  sourceDeezerForCreators: {
    id: 'app.outreach.resultsV2.source.deezerForCreators',
    defaultMessage: 'Deezer for Creators',
  },
  sourceYoutubeAnalytics: {
    id: 'app.outreach.resultsV2.source.youtubeAnalytics',
    defaultMessage: 'YouTube Analytics',
  },

  // warm people
  warmTitle: { id: 'app.outreach.resultsV2.warm.title', defaultMessage: 'Warm people for your next song' },
  warmBody: {
    id: 'app.outreach.resultsV2.warm.body',
    defaultMessage:
      'They listened, replied or added {song}. Plug pitches them first for {next}, with "you liked {song}" in the pitch.',
  },
  warmBodyNoNext: {
    id: 'app.outreach.resultsV2.warm.bodyNoNext',
    defaultMessage:
      'They listened, replied or added {song}. Add your next song to the catalog and Plug pitches them first.',
  },
  warmButton: { id: 'app.outreach.resultsV2.warm.button', defaultMessage: 'Pitch {next} to them first' },
  warmFailed: {
    id: 'app.outreach.resultsV2.warm.failed',
    defaultMessage: 'Plug could not start that campaign. Try again.',
  },

  // link clicks
  clicksTitle: { id: 'app.outreach.resultsV2.clicks.title', defaultMessage: 'Pitch page clicks' },
  clicksMeta: {
    id: 'app.outreach.resultsV2.clicks.meta',
    defaultMessage: '{count, plural, one {# click} other {# clicks}}',
  },
  clicksNone: { id: 'app.outreach.resultsV2.clicks.none', defaultMessage: 'No click from a pitch page yet.' },

  // adds
  addsTitle: { id: 'app.outreach.resultsV2.adds.title', defaultMessage: 'Adds' },
  addsIntro: {
    id: 'app.outreach.resultsV2.adds.intro',
    defaultMessage: 'Found by Plug in the playlist data, or marked by you from a reply.',
  },
  addsMeta: { id: 'app.outreach.resultsV2.adds.meta', defaultMessage: '{count} · {followers} followers' },
  addsNone: {
    id: 'app.outreach.resultsV2.adds.none',
    defaultMessage: 'No add yet. Plug checks the playlists every day and tells you about each add.',
  },
  colWhere: { id: 'app.outreach.resultsV2.adds.where', defaultMessage: 'Where' },
  colFollowers: { id: 'app.outreach.resultsV2.adds.followers', defaultMessage: 'Followers' },
  colPosition: { id: 'app.outreach.resultsV2.adds.position', defaultMessage: 'Position' },
  colStreams: { id: 'app.outreach.resultsV2.adds.streams', defaultMessage: 'Streams from it' },
  addedOn: { id: 'app.outreach.resultsV2.adds.addedOn', defaultMessage: 'added {date}' },
  sourceDetected: { id: 'app.outreach.resultsV2.adds.detected', defaultMessage: 'found by Plug' },
  sourceReply: { id: 'app.outreach.resultsV2.adds.reply', defaultMessage: 'from a reply' },
  sourceManual: { id: 'app.outreach.resultsV2.adds.manual', defaultMessage: 'marked by you' },

  // what worked
  workedTitle: { id: 'app.outreach.resultsV2.worked.title', defaultMessage: 'What worked' },
  workedIntro: {
    id: 'app.outreach.resultsV2.worked.intro',
    defaultMessage: 'Plug changes who it picks next from this. You do not have to do anything.',
  },
  byKind: { id: 'app.outreach.resultsV2.worked.byKind', defaultMessage: 'By kind · replies' },
  bySize: { id: 'app.outreach.resultsV2.worked.bySize', defaultMessage: 'Playlist size · adds' },
  byAngle: { id: 'app.outreach.resultsV2.worked.byAngle', defaultMessage: 'The pitch led with · replies' },
  tooFew: { id: 'app.outreach.resultsV2.worked.tooFew', defaultMessage: 'Too few pitches yet' },
  sizeSmall: { id: 'app.outreach.resultsV2.worked.size.small', defaultMessage: 'Under 5,000' },
  sizeMedium: { id: 'app.outreach.resultsV2.worked.size.medium', defaultMessage: '5,000 to 30,000' },
  sizeLarge: { id: 'app.outreach.resultsV2.worked.size.large', defaultMessage: '30,000+' },
  angleOther: { id: 'app.outreach.resultsV2.worked.angle.other', defaultMessage: 'Other' },
  rate: { id: 'app.outreach.resultsV2.worked.rate', defaultMessage: '{percent}%' },
  // The "learned" line: fixed text per `learned.sentenceKey`, never AI text (controller ruling).
  learnedSmallPlaylists: {
    id: 'app.outreach.resultsV2.learned.smallPlaylists',
    defaultMessage:
      'Plug now picks more small playlists for {song}. Playlists under 5,000 followers add your song more often than big ones.',
  },
  learnedBlogs: {
    id: 'app.outreach.resultsV2.learned.blogs',
    defaultMessage: 'Plug now picks more blogs for {song}. Blogs and magazines answer your pitches more often.',
  },
  learnedFewerCreators: {
    id: 'app.outreach.resultsV2.learned.fewerCreators',
    defaultMessage: 'Plug now pitches fewer creators for {song}. Creators rarely answer your pitches.',
  },

  // all songs (n2)
  allTitle: { id: 'app.outreach.resultsV2.all.title', defaultMessage: 'Results' },
  allIntro: { id: 'app.outreach.resultsV2.all.intro', defaultMessage: 'Every song that Plug pitched, side by side.' },
  colSong: { id: 'app.outreach.resultsV2.all.song', defaultMessage: 'Song' },
  colPitched: { id: 'app.outreach.resultsV2.all.pitched', defaultMessage: 'Pitched' },
  colListened: { id: 'app.outreach.resultsV2.all.listened', defaultMessage: 'Listened' },
  colReplied: { id: 'app.outreach.resultsV2.all.replied', defaultMessage: 'Replied' },
  colAdds: { id: 'app.outreach.resultsV2.all.adds', defaultMessage: 'Adds' },
  colReach: { id: 'app.outreach.resultsV2.all.reach', defaultMessage: 'Reach' },
  statusPitching: { id: 'app.outreach.resultsV2.all.pitching', defaultMessage: 'Pitching · day {day}' },
  statusPaused: { id: 'app.outreach.resultsV2.all.paused', defaultMessage: 'Paused · day {day}' },
  statusEnded: { id: 'app.outreach.resultsV2.all.ended', defaultMessage: 'Ended {date}' },
  statusEndedPlain: { id: 'app.outreach.resultsV2.all.endedPlain', defaultMessage: 'Ended' },
  statusNotStarted: { id: 'app.outreach.resultsV2.all.notStarted', defaultMessage: 'Not started' },
  allEmpty: {
    id: 'app.outreach.resultsV2.all.empty',
    defaultMessage: 'No song pitched yet. Start a campaign and its results show here.',
  },
  pitchASong: { id: 'app.outreach.resultsV2.all.pitchASong', defaultMessage: 'Pitch a song' },
});
